import config from "config/config.js";
import getFreshToken from "api/xsrfToken.js";

const tbProfile = () => {
  // const endpoint = `${config.baseUrl}/api/tb/restaurants/update`;
  // const endpoint = "https://www.foodiestrip.com/api/tb/restaurants/update";
  const xsrfToken = getFreshToken();
  // const endpoint = `https://www.foodiestrip.com/api/tb/profile`;
  const endpoint = `${config.baseUrl}/api/user/profile`;
  console.log("tokensssssssss", xsrfToken);
  const options = {
    method: "get",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": `${config.baseUrl}`,
      "Access-Control-Allow-Credentials": true,
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": xsrfToken
    },
    credentials: "include"
  };
  return fetch(endpoint, options)
    .then(response => response.json())
    .then(res => {
      if (res.error && res.error.status) {
        if (res.error.status === 401) {
          console.log("error 401");
          return null;
        } else {
          console.log("generic error");
          return null;
        }
      }
      return res;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errore", e);
    });
};

export default tbProfile;
